import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

import type { EffectiveRole } from "../auth/types";
import { useAuth } from "../hooks/useAuth";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchUserDetailsByEmail, selectRoles } from "../store/roleSlice";

export type RoleContextType = {
  roles: EffectiveRole[];
  setRole: (_r: EffectiveRole) => void;
  setRoles: (_r: EffectiveRole[]) => void;
};

export const useRole = (): RoleContextType => {
  const dispatch = useAppDispatch();
  const roles = useAppSelector(selectRoles);

  const { account } = useAuth();
  const { accounts } = useMsal();
  const email =
    (accounts[0] as any)?.username ||
    (account as any)?.userName ||
    (accounts[0] as any)?.idTokenClaims?.preferred_username ||
    "";

  useEffect(() => {
    if (email) {
      dispatch(fetchUserDetailsByEmail(email));
    }
  }, [dispatch, email]);

  const setRole = () => {
    // no-op or keep existing to avoid breaking call sites
  };
  const setRoles = () => {
    // no-op
  };

  return { roles, setRole, setRoles };
};
